/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsIcon } from '@squiz/sds';
import { ICON_THUMB_DOWN_TWO_TONE, ICON_THUMB_UP_TWO_TONE } from 'libs/sds/src/Icons';
import React from 'react';
import { AiRatingsProps } from './AiRatings.props';

export const AiRatings = ({ ai }: AiRatingsProps): JSX.Element => {
  return (
    <div className="ai-ratings">
      <div className="ai-ratings__positive" data-id="AI Ratings Positive">
        <SdsIcon svg={ICON_THUMB_UP_TWO_TONE} />
        {ai.positiveCount}
      </div>
      <div className="ai-ratings__negative" data-id="AI Ratings Negative">
        <SdsIcon svg={ICON_THUMB_DOWN_TWO_TONE} />
        {ai.negativeCount}
      </div>
    </div>
  );
};
